import React from "react";
import './Body26.css';
import {Link} from "react-router-dom"
import picture375 from './source/picture375.png'
import picture376 from './source/picture376.png'
import picture377 from './source/picture377.png'
import picture378 from './source/picture378.png'
import picture379 from './source/picture379.png'
import picture380 from './source/picture380.png'






function Body26() {

  return (
    <div className="body26">
      <div className="body26-box1">
        <div className="body26-box2">
          <div className="body26-box3">Ostrožská Nová Ves</div>
          <div className="body26-box5"><div className="body26-box4"></div></div>
          <div className="body26-box6">
          <img className="body26-box6-picture" src={picture375} alt="picture1"/>
          <img className="body26-box6-picture" src={picture376} alt="picture1"/>
          <img className="body26-box6-picture" src={picture377} alt="picture1"/>
          <img className="body26-box6-picture2" src={picture378} alt="picture1"/>
          <img className="body26-box6-picture2" src={picture379} alt="picture1"/>
          <img className="body26-box6-picture2" src={picture380} alt="picture1"/>
          </div>
          <div className="body26-box8"><div className="body26-box7"><Link to="/PageProjekty">Zpět</Link></div></div>
        </div> 
      </div> 
    </div>
  );
}

export default Body26;
